import Button from '../form/Button'
import MedalOutlinedIcon from '../../../assets/icons/medal-outlined.svg?react'
import { useI18N } from '../../../libraries/i18n/hook'

const JoinPremiumButton = () => {
  const { t } = useI18N()
  const handleUpgradeClick = () => {
    window.open('https://www.bloombyzrive.com/bloompro#bloompro-pricing', '_blank', 'noopener,noreferrer')
  }
  return <Button variant='premium' size='sm' onClick={handleUpgradeClick}><MedalOutlinedIcon />{t('premium.cta.button')}</Button>
}

export default JoinPremiumButton
